import React from 'react';
import Button from '../../../Atoms/Button/Button';
import Previous from '../../../../assets/RemoteOrder/icons/Previous.svg';
import Next from '../../../../assets/RemoteOrder/icons/Next.svg';
import { ternaryCheck } from '../../../../Utils/WindowUtils';

const Controls = ({ className, btnName, ariaLabel, currentSlide, onClick, buttonProps, prevButtonText, isOnboarding }: any) => {
  const previousText=ternaryCheck(!!prevButtonText, prevButtonText, 'Previous')
  return (
    <>
      <Button
        testAutoId={`${btnName}-btntestid`}
        className={className}
        aria-label={btnName}
        aria-disabled={ariaLabel}
        data-currentslide={currentSlide}
        tabIndex = {0}
        onClick={onClick}
      >
        {btnName.includes(previousText) ? <Previous /> : <Next />}
        {isOnboarding && buttonProps}
      </Button>
    </>
  );
};

export default Controls;
